import { useState } from 'react';
import './App.scss';
import * as React from 'react';
import AppNavigation from './NavigationRoutes/appNavigation';
import * as token from '../src/services/commonMethods';
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from '../src/Store/store';
import { CustomThemeProvider } from './ThemeProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { getHealthCheck } from './services/commonSearch';
import { fixToken } from './utils/pipes/pipes';
import './Interceptor/AppInterceptor';
import { XSRF_RESPONSE_KEY, setXsrfToken } from './Interceptor/AppInterceptor';
import ScrollToTop from './NavigationRoutes/ScrollToTop';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const App = () => {
  // const isBrowserDefaulDark = () =>
  //   window.matchMedia("(prefers-color-scheme: dark)").matches;
  const [headerShow, setHeaderShow] = useState(false);
  // const getDefaultTheme = () => {
  //   const localStorageTheme = localStorage.getItem("default-theme");
  //   const browserDefault = isBrowserDefaulDark() ? "dark" : "light";
  //   return localStorageTheme || browserDefault;
  // };
  // const [theme, setTheme] = useState(getDefaultTheme());
  const queryClient = new QueryClient();
  const [isXsrfLoaded, setIsXsrfLoaded] = useState(true);

  useEffect(() => {
    if (token.getCookie1('token')) {
      setHeaderShow(true);
    } else {
      setHeaderShow(false);
    }
    localStorage.setItem('currentApp', 'USER');
    if (!localStorage.getItem('userRoles')) {
      localStorage.setItem('userRoles', JSON.stringify(['ROLE_RUNNER']));
    }
    // healthCheck();
  }, []);

  const checkHeaderShow = (val) => {
    if (val) {
      setHeaderShow(true);
    } else {
      setHeaderShow(false);
    }
  };

  const healthCheck = async () => {
    try {
      const response = await getHealthCheck();
      if (response?.status) {
        if (response['headers'] && response['headers'][XSRF_RESPONSE_KEY]) {
          const token = fixToken(response['headers'][XSRF_RESPONSE_KEY]);
          setXsrfToken(token);
          setIsXsrfLoaded(true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <CustomThemeProvider>
          <AppNavigation checkHeaderShowOrHide={checkHeaderShow} />
        </CustomThemeProvider>
      </Provider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
